import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INFO_MESSAGE: `${cleanedFilename(__filename)}-info-message`,
  WARNING_MESSAGE: `${cleanedFilename(__filename)}-warning-message`,
};
